/*
 * Copyright (c) 2020. Sonrai Analytics Limited
 * Developed by Warren Dowey
 */

import { Injectable } from '@angular/core';
import { CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js';
import { OrganisationModel } from '@app/models/organisation.model';
import { OrganisationCognitoUser } from '@app/models/cognito-organisation-user.model';
import {MyPermissionsModel} from '@app/models/my-permissions.model';

export interface Credentials {
  userId?: string;
  userName?: string;
  sessionId?: string;
  refreshToken?: string;
  accessToken?: string;
  idToken?: string;
}

@Injectable()
export class AuthUserService {
  private _user: OrganisationCognitoUser;
  private _userPermissions: MyPermissionsModel[] = [];
  private _organisation: OrganisationModel;
  private _credentials: Credentials;
  private _cognitoUser: CognitoUser;
  private _cognitoSession: CognitoUserSession;

  constructor() {}

  get user(): OrganisationCognitoUser {
    return this._user;
  }

  set user(value: OrganisationCognitoUser) {
    this._user = value;
  }

  get userPermissions(): MyPermissionsModel[] {
    return this._userPermissions;
  }

  set userPermissions(value: MyPermissionsModel[]) {
    this._userPermissions = value;
  }

  get organisation(): OrganisationModel {
    return this._organisation;
  }

  set organisation(value: OrganisationModel) {
    this._organisation = value;
  }

  get credentials(): Credentials {
    return this._credentials;
  }

  set credentials(value: Credentials) {
    this._credentials = value;
  }

  get cognitoUser(): CognitoUser {
    return this._cognitoUser;
  }

  set cognitoUser(value: CognitoUser) {
    this._cognitoUser = value;
  }

  get cognitoSession(): CognitoUserSession {
    return this._cognitoSession;
  }

  set cognitoSession(value: CognitoUserSession) {
    this._cognitoSession = value;
  }
}
